import React, { useState } from 'react'
import { Typography, Button, Box, useTheme } from '@mui/material'
import { ExpandMore, ExpandLess } from '@mui/icons-material'

const ExpandableText = ({
  text,
  initialChars = 150,
  sx,
  buttonSx,
  fontSize,
}) => {
  const [showAll, setShowAll] = useState(false)
  const theme = useTheme()

  const needsTruncation = text.length > initialChars
  const truncatedText = showAll
    ? text
    : `${text.slice(0, initialChars)}${needsTruncation ? '...' : ''}`

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.paragraph,
          textAlign: 'justify',
          lineHeight: 1.8,
          fontSize: '1rem',
        }}
      >
        {truncatedText}

        {needsTruncation && (
          <Button
            variant="text"
            onClick={() => setShowAll(!showAll)}
            sx={{
              position: 'relative',
              display: 'inline',
              px: 0.5,
              minWidth: 'auto',
              border: 'none',
              boxshadow: 'none',
              backgroundColor: 'transparent',
              textTransform: 'uppercase',
              fontWeight: theme.typography.fontWeightMedium,
              fontSize: fontSize || '0.875rem',
              borderRadius: 4,
              color: theme.palette.text.secondary,
              verticalAlign: 'baseline',
              '&:hover': {
                backgroundColor: 'transparent',
                color: theme.palette.text.main,
                border: 'none',
                boxshadow: 'none',
              },
              ...buttonSx,
            }}
            startIcon={
              showAll ? (
                <ExpandLess sx={{ fontSize: 18 }} />
              ) : (
                <ExpandMore sx={{ fontSize: 18 }} />
              )
            }
          >
            {showAll ? 'Less' : 'More'}
          </Button>
        )}
      </Typography>
    </Box>
  )
}

export default ExpandableText
